
// $(document).on('click','.mobile-facets__summary', function(){
//     $(this).next('.mobile-facets__submenu').toggle();
// });

if ($(window).width() < 768) {
  $(".highlish-one .slideshow-container").slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    cssEase: "linear",
    pauseOnHover: true,
    slidesToShow: 1.5,
    slidesToScroll: 1,
  });
} else {
  var in_length = $(".product-ingredient .ingredient-item").length;
  console.log(in_length, "in_length");
  if (in_length == 1) {
    $(".product-ingredient").addClass("single_ingredient");
  }
  if (in_length >= 3) {
    $(".product-ingredient").slick({
      centerMode: true,
      centerPadding: "150px",
      slidesToShow: 3,
      prevArrow:
        '<button type="button" class="slick-prev">' +
        '<svg width="58" height="57" viewBox="0 0 58 57" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<rect x="58" y="57" width="58" height="57" rx="28.5" transform="rotate(-180 58 57)" fill="#742A00"/>' +
        '<path d="M36.7071 27.7929C37.0976 28.1834 37.0976 28.8166 36.7071 29.2071L30.3431 35.5711C29.9526 35.9616 29.3195 35.9616 28.9289 35.5711C28.5384 35.1805 28.5384 34.5474 28.9289 34.1569L34.5858 28.5L28.9289 22.8431C28.5384 22.4526 28.5384 21.8195 28.9289 21.4289C29.3195 21.0384 29.9526 21.0384 30.3431 21.4289L36.7071 27.7929ZM22 27.5L36 27.5L36 29.5L22 29.5L22 27.5Z" fill="#E0DFD5"/>' +
        "</svg>" +
        "</button>",
      nextArrow:
        '<button type="button" class="slick-next">' +
        '<svg width="58" height="57" viewBox="0 0 58 57" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<rect x="58" y="57" width="58" height="57" rx="28.5" transform="rotate(-180 58 57)" fill="#742A00"/>' +
        '<path d="M36.7071 27.7929C37.0976 28.1834 37.0976 28.8166 36.7071 29.2071L30.3431 35.5711C29.9526 35.9616 29.3195 35.9616 28.9289 35.5711C28.5384 35.1805 28.5384 34.5474 28.9289 34.1569L34.5858 28.5L28.9289 22.8431C28.5384 22.4526 28.5384 21.8195 28.9289 21.4289C29.3195 21.0384 29.9526 21.0384 30.3431 21.4289L36.7071 27.7929ZM22 27.5L36 27.5L36 29.5L22 29.5L22 27.5Z" fill="#E0DFD5"/>' +
        "</svg>" +
        "</button>",
    });
  }
}
$(".tab-title").click(function () {
  $(".tab-title").removeClass("active");
  $(this).addClass("active");
  var index = $(this).attr("data-index");
  $(".featured-slider").hide().removeClass("active");
  $(".featured-slider.tabcontent-" + index)
    .show()
    .addClass("active");
  $(".slideshow__control-wrapper").each(function () {
    let $this = $(this);
    let $activeDot = $this.find(
      ".slider-counter__link--dots.slider-counter__link--active"
    );
    let x = $activeDot.offset()?.left || null;
    let xx = $this.offset()?.left || null;

    if (x !== null && xx !== null) {
      let xxx = xx - x + $this.width() / 2 - $activeDot.width() / 2;
      $this.css("transform", `translateX(${xxx}px)`);
    }
  });
});

$(".section-multiple_video .contains-card").slick({
  arrows: true,
  dots: true,
  slidesToShow: 4.5,
  slidesToScroll: 1,
  infinite: false,
  prevArrow:
    '<button type="button" class="slick-prev">' +
    '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M11.0063 0.22522H4.99368C4.33784 0.224999 3.68838 0.354013 3.08242 0.604891C2.47646 0.855769 1.92587 1.22359 1.46212 1.68734C0.998373 2.15109 0.630549 2.70168 0.379671 3.30764C0.128793 3.9136 -0.000221022 4.56306 2.84233e-07 5.2189V11.2315C-0.000221022 11.8874 0.128793 12.5368 0.379671 13.1428C0.630549 13.7488 0.998373 14.2993 1.46212 14.7631C1.92587 15.2268 2.47646 15.5947 3.08242 15.8455C3.68838 16.0964 4.33784 16.2254 4.99368 16.2252H11.0063C11.6622 16.2254 12.3116 16.0964 12.9176 15.8455C13.5235 15.5947 14.0741 15.2268 14.5379 14.7631C15.0016 14.2993 15.3695 13.7488 15.6203 13.1428C15.8712 12.5368 16.0002 11.8874 16 11.2315V5.2189C16.0002 4.56306 15.8712 3.9136 15.6203 3.30764C15.3695 2.70168 15.0016 2.15109 14.5379 1.68734C14.0741 1.22359 13.5235 0.855769 12.9176 0.604891C12.3116 0.354013 11.6622 0.224999 11.0063 0.22522ZM10.2956 8.9629L7.11411 12.1444C7.02143 12.2369 6.91144 12.3103 6.7904 12.3604C6.66936 12.4104 6.53965 12.4362 6.40867 12.4361C6.27769 12.436 6.14801 12.4101 6.02703 12.3599C5.90605 12.3097 5.79614 12.2362 5.70358 12.1435C5.61102 12.0509 5.53762 11.9409 5.48756 11.8198C5.43751 11.6988 5.41179 11.5691 5.41187 11.4381C5.41203 11.1736 5.51726 10.9199 5.70442 10.733L8.21389 8.22522L5.70442 5.71743C5.51726 5.53049 5.41203 5.27687 5.41187 5.01234C5.41171 4.74782 5.51664 4.49406 5.70358 4.3069C5.89052 4.11975 6.14414 4.01451 6.40867 4.01435C6.67319 4.0142 6.92695 4.11913 7.11411 4.30606L10.2956 7.48754C10.3922 7.5839 10.4679 7.69913 10.5181 7.82605C10.5682 7.95296 10.5916 8.08884 10.5869 8.22522V8.25722C10.5871 8.52175 10.4823 8.77555 10.2956 8.9629Z" fill="#EF7F1B"/>' +
    "</svg>" +
    "</button>",
  nextArrow:
    '<button type="button" class="slick-next">' +
    '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M11.0063 0.22522H4.99368C4.33784 0.224999 3.68838 0.354013 3.08242 0.604891C2.47646 0.855769 1.92587 1.22359 1.46212 1.68734C0.998373 2.15109 0.630549 2.70168 0.379671 3.30764C0.128793 3.9136 -0.000221022 4.56306 2.84233e-07 5.2189V11.2315C-0.000221022 11.8874 0.128793 12.5368 0.379671 13.1428C0.630549 13.7488 0.998373 14.2993 1.46212 14.7631C1.92587 15.2268 2.47646 15.5947 3.08242 15.8455C3.68838 16.0964 4.33784 16.2254 4.99368 16.2252H11.0063C11.6622 16.2254 12.3116 16.0964 12.9176 15.8455C13.5235 15.5947 14.0741 15.2268 14.5379 14.7631C15.0016 14.2993 15.3695 13.7488 15.6203 13.1428C15.8712 12.5368 16.0002 11.8874 16 11.2315V5.2189C16.0002 4.56306 15.8712 3.9136 15.6203 3.30764C15.3695 2.70168 15.0016 2.15109 14.5379 1.68734C14.0741 1.22359 13.5235 0.855769 12.9176 0.604891C12.3116 0.354013 11.6622 0.224999 11.0063 0.22522ZM10.2956 8.9629L7.11411 12.1444C7.02143 12.2369 6.91144 12.3103 6.7904 12.3604C6.66936 12.4104 6.53965 12.4362 6.40867 12.4361C6.27769 12.436 6.14801 12.4101 6.02703 12.3599C5.90605 12.3097 5.79614 12.2362 5.70358 12.1435C5.61102 12.0509 5.53762 11.9409 5.48756 11.8198C5.43751 11.6988 5.41179 11.5691 5.41187 11.4381C5.41203 11.1736 5.51726 10.9199 5.70442 10.733L8.21389 8.22522L5.70442 5.71743C5.51726 5.53049 5.41203 5.27687 5.41187 5.01234C5.41171 4.74782 5.51664 4.49406 5.70358 4.3069C5.89052 4.11975 6.14414 4.01451 6.40867 4.01435C6.67319 4.0142 6.92695 4.11913 7.11411 4.30606L10.2956 7.48754C10.3922 7.5839 10.4679 7.69913 10.5181 7.82605C10.5682 7.95296 10.5916 8.08884 10.5869 8.22522V8.25722C10.5871 8.52175 10.4823 8.77555 10.2956 8.9629Z" fill="#EF7F1B"/>' +
    "</svg>" +
    "</button>",
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1.8,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
      },
    },
  ],
});

$(".highlish-two .slideshow-container").slick({
  arrows: true,
  dots: false,
  slidesToShow: 2,
  slidesToScroll: 2,
  infinite: false,
  prevArrow:
    '<button type="button" class="slick-prev">' +
    '<svg width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M0.681961 0.958847H2.17696L5.32296 3.93585L2.17696 6.92585H0.681961L3.82796 3.93585L0.681961 0.958847Z" fill="#FAFAFA"/>' +
    "</svg>" +
    "</button>",
  nextArrow:
    '<button type="button" class="slick-next">' +
    '<svg width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M0.681961 0.958847H2.17696L5.32296 3.93585L2.17696 6.92585H0.681961L3.82796 3.93585L0.681961 0.958847Z" fill="#FAFAFA"/>' +
    "</svg>" +
    "</button>",
  responsive: [
    {
      breakpoint: 600,
      settings: {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 7000,
        cssEase: "linear",
        pauseOnHover: true,
        slidesToShow: 1.5,
        slidesToScroll: 1,
      },
    },
  ],
});
$(".testimonie-inner").slick({
  arrows: true,
  dots: true,
  slidesToShow: 2.65,
  slidesToScroll: 1,
  prevArrow:
    '<button type="button" class="slick-prev">' +
    '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M11.0063 0.22522H4.99368C4.33784 0.224999 3.68838 0.354013 3.08242 0.604891C2.47646 0.855769 1.92587 1.22359 1.46212 1.68734C0.998373 2.15109 0.630549 2.70168 0.379671 3.30764C0.128793 3.9136 -0.000221022 4.56306 2.84233e-07 5.2189V11.2315C-0.000221022 11.8874 0.128793 12.5368 0.379671 13.1428C0.630549 13.7488 0.998373 14.2993 1.46212 14.7631C1.92587 15.2268 2.47646 15.5947 3.08242 15.8455C3.68838 16.0964 4.33784 16.2254 4.99368 16.2252H11.0063C11.6622 16.2254 12.3116 16.0964 12.9176 15.8455C13.5235 15.5947 14.0741 15.2268 14.5379 14.7631C15.0016 14.2993 15.3695 13.7488 15.6203 13.1428C15.8712 12.5368 16.0002 11.8874 16 11.2315V5.2189C16.0002 4.56306 15.8712 3.9136 15.6203 3.30764C15.3695 2.70168 15.0016 2.15109 14.5379 1.68734C14.0741 1.22359 13.5235 0.855769 12.9176 0.604891C12.3116 0.354013 11.6622 0.224999 11.0063 0.22522ZM10.2956 8.9629L7.11411 12.1444C7.02143 12.2369 6.91144 12.3103 6.7904 12.3604C6.66936 12.4104 6.53965 12.4362 6.40867 12.4361C6.27769 12.436 6.14801 12.4101 6.02703 12.3599C5.90605 12.3097 5.79614 12.2362 5.70358 12.1435C5.61102 12.0509 5.53762 11.9409 5.48756 11.8198C5.43751 11.6988 5.41179 11.5691 5.41187 11.4381C5.41203 11.1736 5.51726 10.9199 5.70442 10.733L8.21389 8.22522L5.70442 5.71743C5.51726 5.53049 5.41203 5.27687 5.41187 5.01234C5.41171 4.74782 5.51664 4.49406 5.70358 4.3069C5.89052 4.11975 6.14414 4.01451 6.40867 4.01435C6.67319 4.0142 6.92695 4.11913 7.11411 4.30606L10.2956 7.48754C10.3922 7.5839 10.4679 7.69913 10.5181 7.82605C10.5682 7.95296 10.5916 8.08884 10.5869 8.22522V8.25722C10.5871 8.52175 10.4823 8.77555 10.2956 8.9629Z" fill="#EF7F1B"/>' +
    "</svg>" +
    "</button>",
  nextArrow:
    '<button type="button" class="slick-next">' +
    '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M11.0063 0.22522H4.99368C4.33784 0.224999 3.68838 0.354013 3.08242 0.604891C2.47646 0.855769 1.92587 1.22359 1.46212 1.68734C0.998373 2.15109 0.630549 2.70168 0.379671 3.30764C0.128793 3.9136 -0.000221022 4.56306 2.84233e-07 5.2189V11.2315C-0.000221022 11.8874 0.128793 12.5368 0.379671 13.1428C0.630549 13.7488 0.998373 14.2993 1.46212 14.7631C1.92587 15.2268 2.47646 15.5947 3.08242 15.8455C3.68838 16.0964 4.33784 16.2254 4.99368 16.2252H11.0063C11.6622 16.2254 12.3116 16.0964 12.9176 15.8455C13.5235 15.5947 14.0741 15.2268 14.5379 14.7631C15.0016 14.2993 15.3695 13.7488 15.6203 13.1428C15.8712 12.5368 16.0002 11.8874 16 11.2315V5.2189C16.0002 4.56306 15.8712 3.9136 15.6203 3.30764C15.3695 2.70168 15.0016 2.15109 14.5379 1.68734C14.0741 1.22359 13.5235 0.855769 12.9176 0.604891C12.3116 0.354013 11.6622 0.224999 11.0063 0.22522ZM10.2956 8.9629L7.11411 12.1444C7.02143 12.2369 6.91144 12.3103 6.7904 12.3604C6.66936 12.4104 6.53965 12.4362 6.40867 12.4361C6.27769 12.436 6.14801 12.4101 6.02703 12.3599C5.90605 12.3097 5.79614 12.2362 5.70358 12.1435C5.61102 12.0509 5.53762 11.9409 5.48756 11.8198C5.43751 11.6988 5.41179 11.5691 5.41187 11.4381C5.41203 11.1736 5.51726 10.9199 5.70442 10.733L8.21389 8.22522L5.70442 5.71743C5.51726 5.53049 5.41203 5.27687 5.41187 5.01234C5.41171 4.74782 5.51664 4.49406 5.70358 4.3069C5.89052 4.11975 6.14414 4.01451 6.40867 4.01435C6.67319 4.0142 6.92695 4.11913 7.11411 4.30606L10.2956 7.48754C10.3922 7.5839 10.4679 7.69913 10.5181 7.82605C10.5682 7.95296 10.5916 8.08884 10.5869 8.22522V8.25722C10.5871 8.52175 10.4823 8.77555 10.2956 8.9629Z" fill="#EF7F1B"/>' +
    "</svg>" +
    "</button>",
  infinite: false,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
  ],
});
$(document).ready(function () {
  $(".top-bar .slide-container").slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    cssEase: "linear",
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $('[data-fancybox="gallery"]').fancybox({
    buttons: [
      "close", // Only show the close button
    ],
    loop: true, // Allows cycling through images
    arrows: true, // Hide the navigation arrows
    infobar: false, // Hide the image info bar
    toolbar: false, // Hide the toolbar
    smallBtn: true, // Show a smaller close button
    clickOutside: false,
  });
  $(".oc-1,.oc-2").wrapAll('<div class="oc-wrap"></div>');
  $(".oc-3,.oc-4").wrapAll('<div class="oc-wrap"></div>');

$(".product-slick-slide").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    centerPadding: 0,
    centerMode: true,
    pauseOnHover: false,
    arrows: true,
    dots: false,
    speed: 300,
    draggable: false,
    //  centerPadding: '20px',
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          draggable: false,
          arrows: true,
          slidesToScroll: 1,
        },
      },
    ],
});



function initSliders() {
  // Desktop only
  if (window.innerWidth > 768) {
    $(".desktop_product-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      centerMode: false,
      pauseOnHover: true,
    });
  }

  // Mobile only
  if (window.innerWidth <= 768) {
    $(".mobile_product-slider").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      centerMode: false,
      centerPadding: '20px',
      draggable: true
    });
  }
}

// Initialize on page load
$(document).ready(function () {
  initSliders();



});

// Reinitialize on window resize
$(window).resize(function () {
  initSliders();
});


  
$(".product-slick-slide .slick-slide.slick-active").each(function (index) {
    $(this).addClass("active-slide-" + index);
    console.log(index);
  });

  $(".home-product-slide").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    speed: 300,
    prevArrow:
      '<button type="button" class="slick-prev">' +
      '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M11.0063 0.22522H4.99368C4.33784 0.224999 3.68838 0.354013 3.08242 0.604891C2.47646 0.855769 1.92587 1.22359 1.46212 1.68734C0.998373 2.15109 0.630549 2.70168 0.379671 3.30764C0.128793 3.9136 -0.000221022 4.56306 2.84233e-07 5.2189V11.2315C-0.000221022 11.8874 0.128793 12.5368 0.379671 13.1428C0.630549 13.7488 0.998373 14.2993 1.46212 14.7631C1.92587 15.2268 2.47646 15.5947 3.08242 15.8455C3.68838 16.0964 4.33784 16.2254 4.99368 16.2252H11.0063C11.6622 16.2254 12.3116 16.0964 12.9176 15.8455C13.5235 15.5947 14.0741 15.2268 14.5379 14.7631C15.0016 14.2993 15.3695 13.7488 15.6203 13.1428C15.8712 12.5368 16.0002 11.8874 16 11.2315V5.2189C16.0002 4.56306 15.8712 3.9136 15.6203 3.30764C15.3695 2.70168 15.0016 2.15109 14.5379 1.68734C14.0741 1.22359 13.5235 0.855769 12.9176 0.604891C12.3116 0.354013 11.6622 0.224999 11.0063 0.22522ZM10.2956 8.9629L7.11411 12.1444C7.02143 12.2369 6.91144 12.3103 6.7904 12.3604C6.66936 12.4104 6.53965 12.4362 6.40867 12.4361C6.27769 12.436 6.14801 12.4101 6.02703 12.3599C5.90605 12.3097 5.79614 12.2362 5.70358 12.1435C5.61102 12.0509 5.53762 11.9409 5.48756 11.8198C5.43751 11.6988 5.41179 11.5691 5.41187 11.4381C5.41203 11.1736 5.51726 10.9199 5.70442 10.733L8.21389 8.22522L5.70442 5.71743C5.51726 5.53049 5.41203 5.27687 5.41187 5.01234C5.41171 4.74782 5.51664 4.49406 5.70358 4.3069C5.89052 4.11975 6.14414 4.01451 6.40867 4.01435C6.67319 4.0142 6.92695 4.11913 7.11411 4.30606L10.2956 7.48754C10.3922 7.5839 10.4679 7.69913 10.5181 7.82605C10.5682 7.95296 10.5916 8.08884 10.5869 8.22522V8.25722C10.5871 8.52175 10.4823 8.77555 10.2956 8.9629Z" fill="#EF7F1B"/>' +
      "</svg>" +
      "</button>",
    nextArrow:
      '<button type="button" class="slick-next">' +
      '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M11.0063 0.22522H4.99368C4.33784 0.224999 3.68838 0.354013 3.08242 0.604891C2.47646 0.855769 1.92587 1.22359 1.46212 1.68734C0.998373 2.15109 0.630549 2.70168 0.379671 3.30764C0.128793 3.9136 -0.000221022 4.56306 2.84233e-07 5.2189V11.2315C-0.000221022 11.8874 0.128793 12.5368 0.379671 13.1428C0.630549 13.7488 0.998373 14.2993 1.46212 14.7631C1.92587 15.2268 2.47646 15.5947 3.08242 15.8455C3.68838 16.0964 4.33784 16.2254 4.99368 16.2252H11.0063C11.6622 16.2254 12.3116 16.0964 12.9176 15.8455C13.5235 15.5947 14.0741 15.2268 14.5379 14.7631C15.0016 14.2993 15.3695 13.7488 15.6203 13.1428C15.8712 12.5368 16.0002 11.8874 16 11.2315V5.2189C16.0002 4.56306 15.8712 3.9136 15.6203 3.30764C15.3695 2.70168 15.0016 2.15109 14.5379 1.68734C14.0741 1.22359 13.5235 0.855769 12.9176 0.604891C12.3116 0.354013 11.6622 0.224999 11.0063 0.22522ZM10.2956 8.9629L7.11411 12.1444C7.02143 12.2369 6.91144 12.3103 6.7904 12.3604C6.66936 12.4104 6.53965 12.4362 6.40867 12.4361C6.27769 12.436 6.14801 12.4101 6.02703 12.3599C5.90605 12.3097 5.79614 12.2362 5.70358 12.1435C5.61102 12.0509 5.53762 11.9409 5.48756 11.8198C5.43751 11.6988 5.41179 11.5691 5.41187 11.4381C5.41203 11.1736 5.51726 10.9199 5.70442 10.733L8.21389 8.22522L5.70442 5.71743C5.51726 5.53049 5.41203 5.27687 5.41187 5.01234C5.41171 4.74782 5.51664 4.49406 5.70358 4.3069C5.89052 4.11975 6.14414 4.01451 6.40867 4.01435C6.67319 4.0142 6.92695 4.11913 7.11411 4.30606L10.2956 7.48754C10.3922 7.5839 10.4679 7.69913 10.5181 7.82605C10.5682 7.95296 10.5916 8.08884 10.5869 8.22522V8.25722C10.5871 8.52175 10.4823 8.77555 10.2956 8.9629Z" fill="#EF7F1B"/>' +
      "</svg>" +
      "</button>",
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          arrows: true,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".product-slick-slide .slick-next, .product-slick-slide .slick-prev").click(
    function () {
      $(".product-slick-slide .slick-slide.slick-active").each(function (
        index
      ) {
        $(".product-slick-slide .slick-slide").removeClass(
          "active-slide-" + index
        );
        $(this).addClass("active-slide-" + index);
        // console.log(index);
        setTimeout(function () {
          console.log(index);
          var slide_content = $(
            ".product-slick-slide .slick-current.slick-active.slick-center .slide_content"
          ).html();
          $(".first-richtext .rich-text__wrapper .rich-text__blocks").html(
            slide_content
          );
        }, 1000);
      });
    }
  );

  $(".read-more-btn").click(function () {
    var $this = $(this);
    var $moreText = $(".more-text");

    if ($moreText.is(":visible")) {
      $moreText.slideUp();
      $this.text("Read More");
    } else {
      $moreText.slideDown();
      $this.text("Read Less");
    }
  });

  var slide_content = $(
    ".product-slick-slide .slick-current.slick-active.slick-center .slide_content"
  ).html();
  $(".first-richtext .rich-text__wrapper .rich-text__blocks").html(
    slide_content
  );

  window.addSlickSlider();
  window.cart_more_addSlickSlider();
});
$(document).on("click", ".pin_check", function () {
  $("body").addClass("overflow-hidden");
  var $this = $(this),
    $wrap = $this.closest(".pdp_estimate--main"),
    $input = $wrap.find(".pincode_value"),
    val = $input.val(),
    cls_target = `.pin_${val}`,
    time_massage = $(cls_target).val();
  if (!containsOnlyNumbers(val) || val.length != 6) {
    pin_message("Please enter a valid pincode", false);
    return;
  }
  if (time_massage != null) {
    pin_message(time_massage);
    if (
      time_massage.includes("<start-date>") ||
      time_massage.includes("<end-date>")
    ) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      var d = new Date(),
        sd = new Date(),
        ed = new Date(),
        start_val = parseInt(
          $(".pincode_checker_message").find("start-date").html()
        ),
        end_val = parseInt(
          $(".pincode_checker_message").find("end-date").html()
        );
      sd.setDate(d.getDate() + start_val), ed.setDate(d.getDate() + end_val);
      $(".pincode_checker_message")
        .find("start-date")
        .html(sd.toLocaleDateString("en-GB", options));
      $(".pincode_checker_message")
        .find("end-date")
        .html(ed.toLocaleDateString("en-GB", options));
      $("body").removeClass("overflow-hidden");
    }
  } else {
    pin_message("Please enter a valid pincode", false);
  }
});

// validate you can enterd only number
function containsOnlyNumbers(str) {
  return /^\d+$/.test(str);
}

function pin_message(msg, status = true) {
  if (status) {
    $(".pincode_checker_message")
      .html(msg)
      .addClass("sucess")
      .removeClass("error");
  } else {
    $(".pincode_checker_message")
      .html(msg)
      .addClass("error")
      .removeClass("sucess");
  }
}

window.addSlickSlider = () => {
  var $slider = $(".cart_recommend-slider");
  if ($slider.length == 1) {
    if (!$slider.hasClass("slick-initialized")) {
      console.log("slider");
      $(".cart_recommend-slider").slick({
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        prevArrow:
          '<button type="button" class="slick-prev">' +
          '<svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M0.6875 3.93799C0.37684 3.93799 0.125 4.18983 0.125 4.50049C0.125 4.81115 0.37684 5.06299 0.6875 5.06299L0.6875 3.93799ZM17.3977 4.89824C17.6174 4.67857 17.6174 4.32241 17.3977 4.10274L13.818 0.523015C13.5984 0.303345 13.2422 0.303345 13.0225 0.523015C12.8029 0.742684 12.8029 1.09884 13.0225 1.31851L16.2045 4.50049L13.0225 7.68247C12.8029 7.90214 12.8029 8.25829 13.0225 8.47796C13.2422 8.69763 13.5984 8.69763 13.818 8.47796L17.3977 4.89824ZM0.6875 5.06299L17 5.06299L17 3.93799L0.6875 3.93799L0.6875 5.06299Z" fill="black"/>' +
          "</svg>" +
          "</button>",
        nextArrow:
          '<button type="button" class="slick-next">' +
          '<svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M0.6875 3.93799C0.37684 3.93799 0.125 4.18983 0.125 4.50049C0.125 4.81115 0.37684 5.06299 0.6875 5.06299L0.6875 3.93799ZM17.3977 4.89824C17.6174 4.67857 17.6174 4.32241 17.3977 4.10274L13.818 0.523015C13.5984 0.303345 13.2422 0.303345 13.0225 0.523015C12.8029 0.742684 12.8029 1.09884 13.0225 1.31851L16.2045 4.50049L13.0225 7.68247C12.8029 7.90214 12.8029 8.25829 13.0225 8.47796C13.2422 8.69763 13.5984 8.69763 13.818 8.47796L17.3977 4.89824ZM0.6875 5.06299L17 5.06299L17 3.93799L0.6875 3.93799L0.6875 5.06299Z" fill="black"/>' +
          "</svg>" +
          "</button>",
        dots: false,
      });
    }
  }
};

window.cart_more_addSlickSlider = () => {
  var $slider = $(".cart_more_product");
  if ($slider.length == 1) {
    if (!$slider.hasClass("slick-initialized")) {
      console.log("slider");
      $(".cart_more_product").slick({
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        prevArrow:
          '<button type="button" class="slick-prev">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="89" height="89" viewBox="0 0 89 89" fill="none">' +
          '<g filter="url(#filter0_d_12_1882)">' +
          '<path d="M67.3245 42.628C67.3245 28.866 56.174 17.7096 42.4191 17.7096C28.6642 17.7096 17.5137 28.866 17.5137 42.628C17.5137 56.39 28.6642 67.5464 42.4191 67.5464C56.174 67.5464 67.3245 56.39 67.3245 42.628Z" fill="white"></path>' +
          '<path d="M37.466 43.2198L46.8852 34.5482L43.5585 34.5482L34.1768 43.2198L43.5585 51.8914H46.8852L37.466 43.2198Z" fill="black"></path>' +
          "</g>" +
          "<defs>" +
          '<filter id="filter0_d_12_1882" x="0.513672" y="0.709473" width="87.8105" height="87.8369" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
          '<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>' +
          '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>' +
          '<feOffset dx="2" dy="2"></feOffset>' +
          '<feGaussianBlur stdDeviation="9.5"></feGaussianBlur>' +
          '<feComposite in2="hardAlpha" operator="out"></feComposite>' +
          '<feColorMatrix type="matrix" values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.25 0"></feColorMatrix>' +
          '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12_1882"></feBlend>' +
          '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12_1882" result="shape"></feBlend>' +
          "</filter>" +
          "</defs>" +
          "</svg>" +
          "</button>",
        nextArrow:
          '<button type="button" class="slick-next">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="89" height="89" viewBox="0 0 89 89" fill="none">' +
          '<g filter="url(#filter0_d_12_1883)">' +
          '<path d="M17.6755 42.6278C17.6755 56.3899 28.826 67.5462 42.5809 67.5462C56.3358 67.5462 67.4863 56.3899 67.4863 42.6278C67.4863 28.8658 56.3358 17.7095 42.5809 17.7095C28.826 17.7095 17.6755 28.8658 17.6755 42.6278Z" fill="white"></path>' +
          '<path d="M47.534 42.036L38.1148 50.7076H41.4415L50.8232 42.036L41.4415 33.3644H38.1148L47.534 42.036Z" fill="black"></path>' +
          "</g>" +
          "<defs>" +
          '<filter id="filter0_d_12_1883" x="0.675781" y="0.709473" width="87.8105" height="87.8369" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
          '<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>' +
          '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>' +
          '<feOffset dx="2" dy="2"></feOffset>' +
          '<feGaussianBlur stdDeviation="9.5"></feGaussianBlur>' +
          '<feComposite in2="hardAlpha" operator="out"></feComposite>' +
          '<feColorMatrix type="matrix" values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.25 0"></feColorMatrix>' +
          '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12_1883"></feBlend>' +
          '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12_1883" result="shape"></feBlend>' +
          "</filter>" +
          "</defs>" +
          "</svg>" +
          "</button>",
        dots: false,
      });
    }
  }
};

$(document).on("click", ".add_fbt_item", function () {
  var $el = $(this),
    id = $el.attr("data-id") || null,
    data = [];
  if (id) {
    $el.addClass("loading");
    data.push({
      id: id,
      quantity: 1,
      properties: null,
    });
    multipleATC(data, $el);
  }
});
// Start: ATC button
function multipleATC(item_array, $btn = null) {
  this.cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  var items = [];

  item_array.forEach((item) => {
    let myObj = {
      id: item.id,
      quantity: item.quantity,
      properties: item.properties,
    };
    items.push(myObj);
  });

  let formData = {
    items: items,
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((items) => {
      if ($btn) {
        $btn.removeClass("loading");
      }
      setTimeout(() => {
        window.refreshCart();
      });

      console.log(items);
    })
    .catch((error) => {
      console.error("Error:", error);
      if ($btn) {
        $btn.removeClass("loading");
      }
    });
}
try {
  window.refreshCart = () => {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const count = parseInt(
          html.querySelector("cart-drawer-items").getAttribute("item_count")
        );

        const selectors = [
          "cart-drawer-items",
          ".cart-drawer__footer",
          ".drawer__header_wrap",
          ".cart-free-product",
          ".annoucement_dis_cart",
        ];
        console.log(count + "---count");
        if (count > 0) {
          $(".drawer__inner-empty").removeClass("show_empty_drawer");
          $("cart-drawer").removeClass("is-empty");
          $(".annoucement_dis_cart").show();
          document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
            bubble.classList.remove("hidden");
          });
        } else {
          $("cart-drawer").addClass("is-empty");
          $(".drawer__inner-empty").addClass("show_empty_drawer");
          $(".annoucement_dis_cart").hide();
          document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
            bubble.classList.add("hidden");
          });
        }

        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }

        document
          .querySelectorAll(".cart-count-bubble span:first-child")
          .forEach((bubble) => {
            bubble.innerHTML = count;
          });
        document.querySelector(".cart-count-bubble").innerHTML = count;

        console.log("Cart drawer refreshed");
        window.addSlickSlider();
        window.cart_more_addSlickSlider();
          const $btn = $('.cart__checkout-button');
        if ($btn && $btn.length) $btn.attr('disabled', false);
      })
      .catch((e) => {
        console.error("Error refreshing cart drawer:", e);
      });

    window.addSlickSlider();
    window.cart_more_addSlickSlider();
  };
} catch (err) {
  console.error("Error initializing refreshCart:", err);
}

window.handleDiscountChange = function() { 
  var selectedInput = $('input[type="radio"]:checked'),
      $discountHtml = $('.product__info-wrapper .js-discount-price-vari');
  console.log("selectedInput<>><><><>", selectedInput.length, selectedInput);

  if (selectedInput.length > 0) {
    var parentLabel = selectedInput.next('label');
    var discount = parentLabel.find('.option-variant_wrap').data('variant-discount');
    var discountText = discount + '% discount';

    console.log('parentLabel<><><><>', parentLabel, discount);
    $('.product__info-wrapper .js-discount-price-vari').html(discountText)
    if($discountHtml.length > 0){ $discountHtml.text(discountText);}

    console.log("$discountHtml<>><>",$discountHtml);
    console.log('discountText<><><><>', discountText);
  }
}


function formatString(inputString) {
  return inputString
    .trim()
    .toLowerCase()
    .replace(/['"]/g, "")
    .replace(/ /g, "-");
}
$(document).on("click", ".data_slide .tab-title", function (e) {
  e.preventDefault();
  var slide_text = $(this).text();
  let formattedSlide = formatString(slide_text);
  console.log(formattedSlide);
  var slideno = $(
    '.home-product-slide li[data-collection="' + formattedSlide + '"]'
  )
    .closest(".slick-slide")
    .attr("data-slick-index");
  $(".home-product-slide li").removeClass("product-active");
  $(
    '.home-product-slide li[data-collection="' + formattedSlide + '"]'
  ).addClass("product-active");
  console.log(slideno);
  // var slideno = $(this).data('slide');
  $(".home-product-slide").slick("slickGoTo", slideno);
});

$('.home-product-slide li[data-collection="weight-management"]').addClass(
  "product-active"
);
$(document).on(
  "click",
  ".home-product-slide .slick-next, .home-product-slide .slick-prev",
  function () {
    var data_collection = $(
      ".home-product-slide .slick-slide.slick-current.slick-active li"
    ).attr("data-collection");
    $(".data_slide .tab-title[data-tag='" + data_collection + "']").trigger(
      "click"
    );
    console.log(data_collection);
  }
);
const divs = document.querySelectorAll(".testimonial-main .customer-details");
let max = 0;

divs.forEach((div) => {
  if (div.offsetHeight > max) max = div.offsetHeight;
});
$(".testimonial-main .customer-details").height(max + "px");


// $(document).on("click", ".mobile-facets__open-wrapper", function () {
//   $(".mobile-facets__inner .mobile-facets__details.js-filter").attr(
//     "open",
//     "open"
//   );
//   $(".mobile-facets__inner .mobile-facets__details.js-filter").addClass(
//     "menu-opening"
//   );
// });

$(document).on("click", ".product-form__submit", function () {
  const variantId = $(this)
    .parents(".product-form")
    .find('input[name="id"]')
    .val();

  if (!variantId) {
    console.error("Variant ID not found.");
    return;
  }
  setTimeout(() => {
    fetch("/cart.js")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch cart data: ${response.statusText}`);
        }
        return response.json();
      })
      .then((cart) => {
        const cartItem = cart.items.find((item) => item.id == variantId);
        console.log("response");
        setTimeout(function () {
          // $('.popup__image--wrap').show();
        }, 2000);
        if (!cartItem) {
          console.warn(`No cart item found with ID ${variantId}`);
          return;
        }

        // Extract product details
        const productName = cartItem.title; // Product title
        const productPrice = parseFloat(
          cartItem.final_line_price / 100
        ).toFixed(2); // Convert to decimal
        const quabtity = cartItem.quantity;

        // Trigger the Facebook Pixel AddToCart event
        fbq("track", "AddToCart", {
          content_name: productName,
          content_ids: [variantId],
          content_type: "product",
          value: productPrice,
          currency: Shopify.currency.active,
        });

        console.log("Facebook Pixel AddToCart triggered:", {
          content_name: productName,
          content_ids: [variantId],
          content_type: "product",
          value: productPrice,
          currency: Shopify.currency.active,
        });

        // Trigger Google Ads (AW) event
        gtag("event", "add_to_cart", {
          currency: Shopify.currency.active,
          value: productPrice,
          items: [
            {
              id: variantId,
              name: productName,
              price: productPrice,
              quantity: quabtity,
            },
          ],
        });

        console.log("Google Ads AddToCart event triggered:", {
          currency: Shopify.currency.active,
          value: productPrice,
          items: [
            {
              id: variantId,
              name: productName,
              price: productPrice,
              quantity: quabtity,
            },
          ],
        });

        function gtag_report_conversion(url) {
          var callback = function () {
            if (typeof url != "undefined") {
              window.location = url;
            }
          };
          gtag("event", "conversion", {
            send_to: "AW-11245647497/0RPICKLcxPAZEIntq_Ip",
            value: productPrice,
            currency: Shopify.currency.active,
            event_callback: callback,
          });
          console.log("gtag_callback", {
            send_to: "AW-11245647497/0RPICKLcxPAZEIntq_Ip",
            value: productPrice,
            currency: Shopify.currency.active,
            event_callback: callback,
          });
          return false;
        }
      })
      .catch((error) => {
        console.error("Error fetching cart data or processing:", error);
      });
  }, 1000);
});
$(document).on("click", ".cart__checkout-button", function (e) {
  setTimeout(() => {
    // Fetch the current cart data
    fetch("/cart.js")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch cart data: ${response.statusText}`);
        }
        return response.json(); // Parse cart data as JSON
      })
      .then((cart) => {
        // Get all cart item IDs
        const allItemIds = cart.items.map((item) => item.id);

        // Calculate the cart total value
        const cartTotal = cart.total_price / 100; // Shopify cart price is in cents, so we divide by 100

        // Trigger meta event
        fbq("track", "InitiateCheckout", {
          value: cartTotal, // Total value of the cart
          currency: Shopify.currency.active, // Currency used for the transaction
          content_ids: allItemIds.join(","), // IDs of the products being purchased
          content_type: "product",
        });
        console.log("meta AddToCart event triggered:", {
          value: cartTotal, // Total value of the cart
          currency: Shopify.currency.active, // Currency used for the transaction
          content_ids: allItemIds, // IDs of the products being purchased
          content_type: "product",
        });

        // Trigger Google Ads (AW) event
        gtag("event", "conversion", {
          send_to: "AW-11245647497/zeOUCOSkt_AZEIntq_Ip",
          currency: Shopify.currency.active,
          value: cartTotal,
          items: allItemIds.join(","), // Pass all item IDs as a comma-separated string
        });

        console.log("Google Ads AddToCart event triggered:", {
          send_to: "AW-11245647497/zeOUCOSkt_AZEIntq_Ip",
          currency: Shopify.currency.active,
          value: cartTotal,
          item_ids: allItemIds, // Log the cart item IDs
        });
        // const freebieID = 42522203291735
        // const freeInCart = cart.items.every(item => item.id === freebieID);
        // console.log('freeInCart',freeInCart);
        // if(freeInCart){
        //   removeFreeProduct(freebieID)
        // }
      })
      .catch((error) => {
        console.error("Error fetching cart data or processing:", error);
      });
  }, 1000);
});

if ($("body").hasClass("template-product")) {
  var selectedvariant = $(".product-form").find('input[name="id"]').val();
  var variant_price = parseFloat(
    window.variants[selectedvariant].meta_price / 100
  ).toFixed(2);
  gtag("event", "conversion", {
    send_to: "AW-11245647497/DfLpCJmLufAZEIntq_Ip",
    value: variant_price,
    currency: Shopify.currency.active,
  });
  console.log("product_page_loaded", {
    send_to: "AW-11245647497/DfLpCJmLufAZEIntq_Ip",
    value: variant_price,
    currency: Shopify.currency.active,
  });
}

if (localStorage.getItem("popupClosed") === "true") {
  $(".popup__image--wrap").hide(); // Hide the popup if the flag is set
}
$(document).on("click", ".icon__close", function () {
  $(".popup__image--wrap").hide();
  localStorage.setItem("popupClosed", "true");
});

$(document).on("click", ".toggle-btn", function () {
    const $container = $(this).closest(".product-coupons-container");
    const $offers = $container.find(".additional-offers");

    $offers.slideToggle(200);                         // Show/hide the offers section
    $(this).toggleClass("expanded");                  // Toggle class on the button
    $container.toggleClass("active");      
});

// health calculator js
var opts = {
  angle: 0,
  lineWidth: 0.1,
  radiusScale: 0.9,
  pointer: {
    length: 0.2,
    strokeWidth: 0.03,
    color: "#000000",
  },
  limitMax: true,
  limitMin: true,
  colorStart: "#6F6EA0",
  colorStop: "#C0C0DB",
  strokeColor: "#EEEEEE",
  generateGradient: true,
  highDpiSupport: true,

  staticZones: [
    { strokeStyle: "#265728", min: 12, max: 18.5 }, // Zone 2: Light Red
    { strokeStyle: "#805c00", min: 18.5, max: 24.9 }, // Zone 3: Yellow
    { strokeStyle: "#fa5805", min: 25, max: 29.9 }, // Zone 4: Green
    { strokeStyle: "#800000", min: 30, max: 35 }, // Dark red zone
  ],
  staticLabels: {
    font: "10px sans-serif", // Specifies font
    labels: [], // Print labels at these values
    color: "#000000", // Optional: Label text color
    fractionDigits: 0, // Optional: Numerical precision. 0=round off.
  },
};
try {
  var target = document.getElementById("bmi-gauge"); // your canvas element
var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
gauge.maxValue = 35; // set max gauge value
gauge.setMinValue(12); // Prefer setter over gauge.minValue = 0
gauge.animationSpeed = 10; // set animation speed (32 is default value)
gauge.set(27.8); // set actual value
} catch (error) {
  
}


$(document).on("click", ".calculate", function () {
  var calculator = $(this)
    .closest(".health-calculator-detail-block")
    .attr("data-calculator");
  let height = parseFloat(
    $(this)
      .closest(".health-calculator-detail-block." + calculator)
      .find(".height")
      .val()
  );
  let weight = parseFloat(
    $(this)
      .closest(".health-calculator-detail-block." + calculator)
      .find(".weight")
      .val()
  );
  console.log(calculator);
  if (!height || !weight) {
    // alert('Please enter both height and weight.');
    return;
  }

  // Convert height from feet to meters
  height = height * 0.3048;

  // Calculate BMI
  let bmi = weight / (height * height);
  bmi = bmi.toFixed(2);

  // Determine BMI category and angle
  let status = "";
  let angle = 0;
  console.log("bmi", bmi);
  if (bmi < 18.5) {
    status = "Underweight";
    angle = -90; // Starting angle
  } else if (bmi >= 18.5 && bmi <= 24.99) {
    status = "Normal weight";
    angle = 0; // Middle of "Normal weight"
  } else if (bmi >= 25 && bmi <= 29.99) {
    status = "Overweight";
    angle = 45; // Middle of "Overweight"
  } else if (bmi >= 30 && bmi <= 34.99) {
    status = "Obese";
    angle = 90; // Middle of "Obese"
  } else {
    status = "Morbid obesity";
    angle = 135; // Middle of "Morbid Obesity"
  }
  gauge.set(bmi); // set actual value
  // Update gauge arrow
  $(".arrow").css("transform", `rotate(${angle}deg)`);

  // Display BMI value and status
  $("#bmi-value").text(`Your BMI is ${bmi}`);
  $("#bmi-status").text(`You are ${status}`);
});

// Initialize Gauge.js
function bmrGauge(setvalue) {
  var bmr_opts = {
    angle: 0, // Slightly curved gauge
    lineWidth: 0.1, // Thickness of the gauge arc
    radiusScale: 0.9, // Relative radius
    pointer: {
      length: 0.2,
      strokeWidth: 0.03,
      color: "#000000",
    },
    limitMax: true, // Limit the maximum value
    limitMin: true, // Limit the minimum value
    strokeColor: "#EEEEEE", // Background stroke
    generateGradient: true, // Enable gradient
    highDpiSupport: true, // High resolution support

    staticZones: [
      { strokeStyle: "#008000", min: 1000, max: 1500 }, // Low BMR (Green)
      { strokeStyle: "#FFA500", min: 1500, max: 2000 }, // Medium BMR (Orange)
      { strokeStyle: "#FF4500", min: 2000, max: 2500 }, // High BMR (Red)
      { strokeStyle: "#8B0000", min: 2500, max: 3000 }, // Very High BMR (Dark Red)
    ],
    staticLabels: {
      font: "12px sans-serif", // Label font
      labels: [], // Label values
      color: "#000000", // Label text color
      fractionDigits: 0, // Precision for labels
    },
  };

  var bmr_target = document.getElementById("bmrGauge"); // Canvas element
  var bgcalculatorGauge_target = document.getElementById("bgcalculatorGauge");
  var bmr_gauge = new Gauge(bmr_target).setOptions(bmr_opts); // Initialize the gauge
  var bgcalculator_gauge = new Gauge(bgcalculatorGauge_target).setOptions(
    bmr_opts
  ); // Initialize the gauge
  bmr_gauge.maxValue = 3000; // Set max gauge value
  bmr_gauge.setMinValue(1000); // Set min gauge value
  bmr_gauge.animationSpeed = 32; // Animation speed
  bmr_gauge.set(setvalue);
  bgcalculator_gauge.maxValue = 3000; // Set max gauge value
  bgcalculator_gauge.setMinValue(1000); // Set min gauge value
  bgcalculator_gauge.animationSpeed = 32; // Animation speed
  bgcalculator_gauge.set(setvalue);
  console.log(bgcalculator_gauge, "bgcalculator_gauge>>");
}
function calculateBMR() {
  // Get user inputs
  const gender = document.querySelector(".gender").value;
  const age = parseFloat(document.querySelector(".bmr_age").value);
  const weight = parseFloat(document.querySelector(".bmr_weight").value);
  const height = parseFloat(document.querySelector(".bmr_height").value);

  // Validate inputs
  if (!age || !weight || !height || age <= 0 || weight <= 0 || height <= 0) {
    document.querySelector(".bmr_result").innerText =
      "Please enter valid inputs.";
    return;
  }

  // Calculate BMR using Mifflin-St Jeor Equation
  let bmr;
  if (gender === "male") {
    bmr = 10 * weight + 6.25 * height - 5 * age + 5;
  } else if (gender === "female") {
    bmr = 10 * weight + 6.25 * height - 5 * age - 161;
  }

  // Display result
  bmrGauge(bmr);
  document.querySelector(".bmr_result").innerHTML = `
        <span>Your Basal Metabolic Rate (BMR) is:</span>
        <strong>${Math.round(bmr)} calories/day</strong>
      `;
}

$(".bgcalculator").on("click", function () {
  displayGlucoseMessage();
});

function displayGlucoseMessage() {
  const $bgLevelInput = $("#bgcal1"); // Cache the input field
  const $bgResult = $(".bgcalculator_result");
  const bgLevel = parseFloat($bgLevelInput.val()); // Get the input value as a float

  // Validate input
  if (isNaN(bgLevel)) {
    return;
  }

  let message = "";

  // Determine the message based on the blood glucose level
  if (bgLevel < 70) {
    message = `
        Your blood glucose level is <span class="red">low</span>. <br>
        <ul>
          <li>If you are a diabetic and your FBS is always < 80 mg/dL, you may want to talk to your doctor to adjust your insulin or diabetes medicine dosage.</li>
        </ul>
      `;
  } else if (bgLevel <= 99.99) {
    message = `Your Fasting blood sugar is <span class="text-green">Normal</span>.`;
  } else if (bgLevel <= 125.99) {
    message = `
        Your Fasting Blood Sugar is in the <span class="text-amber">borderline</span>. <br>
        <ul>
          <li>Please try to be in the range of 80 - 100 mg/dL.</li>
        </ul>
      `;
  } else {
    message = `
        Your Fasting Blood Sugar is <span class="red">High</span>. <br>
        <ul>
          <li>Please try to be in the range of 80 - 100 mg/dL.</li>
                 </ul>
      `;
  }

  // Clear previous result and append the new message
  bmrGauge(bgLevel);
  $("#msgError").empty().append(message);
  $bgResult.show();
}

$(".iw_calculate").on("click", function () {
  // Get gender and height input value
  const gender = document.querySelector(".iw_gender").value;
  const heightInFeet = parseFloat(
    $(this).closest(".iw_calculator").find(".iw_height").val()
  );

  // Check if the height value is valid (positive number)
  if (isNaN(heightInFeet) || heightInFeet <= 0) {
    alert("Please enter a valid positive height.");
    return;
  }

  // Calculate the ideal weight using the function
  const idealWeight = calculateIdealWeight(gender, heightInFeet);

  // Display the result
  $(".iw_result").empty().append(`Your ideal weight is ${idealWeight} kg`);
});

// Function to calculate ideal weight (same as before)
function calculateIdealWeight(gender, height) {
  if (!height || height <= 0) {
    alert("Please enter a valid height.");
    return;
  }

  let idealWeight;

  if (gender === "male") {
    idealWeight = 50 + 2.3 * (height - 60);
  } else {
    idealWeight = 45.5 + 2.3 * (height - 60);
  }

  return idealWeight.toFixed(2); // Round to 2 decimal places
}

$(".transform-your-life .select_button").click(function (event) {
  event.preventDefault(); // Prevent the default anchor behavior
  var cal_name = $(this).attr("href"); // Get the href value
  $(".health-calculator-detail-block").hide(); // Hide all blocks
  var cal_name2 = cal_name.replace("#", ""); // Remove '#' from the href value
  $(
    ".health-calculator-detail-block[data-calculator='" + cal_name2 + "']"
  ).show(); // Show the relevant block
  console.log(cal_name);
  $(".health-calculator-container").show();
  if (cal_name == "#bmr_calculator") {
    setTimeout(function () {
      bmrGauge(1500);
    }, 0);
  }
  $("body").addClass("open_popup");
});

$(document).on("click", ".close-btn", function () {
  $(".health-calculator-container").hide();
  $("body").removeClass("open_popup");
});

function equalizeHeights() {
  let selectors = [
    ".template-page-health-calculator .multicolumn .inline-richtext",
    ".template-page-health-calculator .multicolumn .multicolumn-card .rte",
  ];

  selectors.forEach((selector) => {
    let maxHeight = 0;

    // Reset height to auto before measuring
    $(selector)
      .css("height", "auto")
      .each(function () {
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
      });

    // Apply max height
    $(selector).height(maxHeight);
  });
}
if ($(window).width() > 990) {
  // Run on document ready and window resize
  $(document).ready(equalizeHeights);
  $(window).resize(equalizeHeights);
}

function updateVariantsBasedOnWeight() {
  // Check if .option_weight exists in the DOM
  if ($('.option_weight').length === 0) {
    return; // Exit early if not found
  }

  $('.option-variant_wrap').hide(); // Hide all initially

  $('.input__btn:checked').each(function() {
    const input_val = $(this).val();
    const inpt_op = $(this).attr("data-option");

    if (inpt_op === "weight") {
      $('.option-variant_wrap').each(function() {
        const variant = $(this).attr('data-variant');
        if (variant && variant.includes(input_val)) {
          $(this).show();
        }
      });
    }
  });
}


$(document).ready(function () {
  updateVariantsBasedOnWeight();
  // window.handleDiscountChange();

  try {
    $('.js-sort-click').on('click', function (e) {
      e.stopPropagation();
      $('body').addClass('mob-sort-active');
      $('.custom-mob__sort-wrapper').addClass('active');
    });

    $(window).on('click', function () {
      $('body').removeClass('mob-sort-active');
      $('.custom-mob__sort-wrapper').removeClass('active');
    });

    // $('.custom-mob__sort-wrapper').on('click', function (e) {
    //   e.stopPropagation();
    // });

    $(document).on('click', '.sorting-close', function (e) {
     e.preventDefault();
     $('body').removeClass('mob-sort-active');
      $('.custom-mob__sort-wrapper').removeClass('active');
    });

  } catch (error) {
    console.error('Error in sort dropdown script:', error);
  }
});


// Run on variant change (e.g. from external call like Shopify)
window.variantchange = (variant) => {
  updateVariantsBasedOnWeight();
  // window.handleDiscountChange();
};


